import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useApi } from "../hooks/useApi";

export default function AddSite() {
    const [siteNumber, setSiteNumber] = useState("");
    const [siteName, setSiteName] = useState("");
    const [siteAddress, setSiteAddress] = useState("");
    const [siteCity, setSiteCity] = useState("");
    const [siteProvince, setSiteProvince] = useState("");
    const [sitePostalCode, setSitePostalCode] = useState("");
    const { apiCall } = useApi();

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await apiCall(`add_site`, {
                method: "POST",
                body: {
                    site_number: siteNumber,
                    site_name: siteName,
                    site_address: siteAddress,
                    site_city: siteCity,
                    site_province: siteProvince,
                    site_postal_code: sitePostalCode,
                },
            });
            const data = await response.json();
            if (!data.success) {
                throw new Error(data.error);
            }

            alert("Project added successfully!");
            window.location.reload(); // Reload the page to see the new site in the list
        } catch (error) {
            console.error("Error adding the site:", error);
            alert(error);
        }
    }

    return (
        <div className="p-6">
            <div className="flex justify-between items-center mb-10">
                <h1 className="text-2xl font-bold">Add New Project</h1>

                <Link to={`/`} className="btn btn-primary self-end">
                    Back
                </Link>
            </div>
            <form onSubmit={handleSubmit} className="space-y-4">
                <input
                    type="text"
                    placeholder="Project #"
                    value={siteNumber}
                    onChange={(e) => setSiteNumber(e.target.value)}
                    className="border p-2 rounded w-full"
                    required
                />
                <input
                    type="text"
                    placeholder="Project Name"
                    value={siteName}
                    onChange={(e) => setSiteName(e.target.value)}
                    className="border p-2 rounded w-full"
                    required
                />
                <input
                    type="text"
                    placeholder="Project Address"
                    value={siteAddress}
                    onChange={(e) => setSiteAddress(e.target.value)}
                    className="border p-2 rounded w-full"
                />
                <input
                    type="text"
                    placeholder="Project City"
                    value={siteCity}
                    onChange={(e) => setSiteCity(e.target.value)}
                    className="border p-2 rounded w-full"
                />
                <input
                    type="text"
                    placeholder="Project Province"
                    value={siteProvince}
                    onChange={(e) => setSiteProvince(e.target.value)}
                    className="border p-2 rounded w-full"
                />
                <input
                    type="text"
                    placeholder="Project Postal Code"
                    value={sitePostalCode}
                    onChange={(e) => setSitePostalCode(e.target.value)}
                    className="border p-2 rounded w-full"
                />
                <button type="submit" className="btn btn-primary">Add Project</button>
                <Link to={`/`}>
                    <button type="button" className="btn btn-cancel ml-4">Cancel</button>
                </Link>
            </form>
        </div>
    );
};